import { useState } from "react";
import { CommonImages } from "../../../../reusableUI/images";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import RadioButton from "../../../../reusableUI/radioBtns";

const CloseDuty = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState("single");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [agree, setAgree] = useState(false);

  if (!isOpen) return null;

  const handleRadioChange = (e) => setSelectedOption(e.target.value);
  const Save = () => {
    // console.log("Saved");
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="flex flex-col items-center bg-white p-5 rounded-md shadow-lg w-96">
        <div className="flex justify-between w-full text-md font-semibold mb-4">
          <p className="text-blue-600">Close Duty</p>
          <img
            src={CommonImages.close}
            onClick={onClose}
            className="h-6 w-6 cursor-pointer"
            alt="Close"
          />
        </div>

        <div className="flex gap-3 mb-4">
          <RadioButton
            label="Single"
            value="single"
            selectedOption={selectedOption}
            onChange={handleRadioChange}
          />
          <RadioButton
            label="Range"
            value="range"
            selectedOption={selectedOption}
            onChange={handleRadioChange}
          />
        </div>

        <div className="flex flex-col items-center">
          <div className="flex flex-row">
            <div className="flex flex-row justify-center items-center gap-2 mb-3">
              <p className="text-[12px]">
                {selectedOption === "single" ? "Date" : "From"}
              </p>

              <DatePicker
                value={fromDate}
                onChange={setFromDate}
                className="p-2 w-[80%] text-[12px]"
                placeholderText="Select a date"
                dateFormat="dd/MM/yyyy"
                clearIcon={null}
                calendarIcon={<FaRegCalendarAlt color="blue" size={16} />}
              />
            </div>

            {selectedOption === "range" && (
              <div className="flex flex-row justify-center items-center gap-2 mb-3">
                <p className="text-[12px]">To</p>
                <DatePicker
                  value={toDate}
                  onChange={setToDate}
                  className="p-2 w-[80%] text-[12px] "
                  placeholderText="Select a date"
                  dateFormat="dd/MM/yyyy"
                  clearIcon={null}
                  calendarIcon={<FaRegCalendarAlt color="blue" size={16} />}
                />
              </div>
            )}
          </div>
          <div className="mb-6 mt-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={agree}
                onChange={() => setAgree(!agree)}
                className="mr-2"
              />
              <p className="text-[12px]">Close the duty with the duty fee</p>
            </label>
          </div>

          <button
            className="bg-custom-gradient text-white p-2 text-[12px] w-24 rounded-md"
            onClick={() => Save()}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseDuty;
